import { useCallback, useState } from "react";
import { publishSurvey } from "../api/survey.api";
import type { SurveyPublishRequest } from "../types/survey.types";

export const usePublishSurvey = () => {
  const [loading, setLoading] = useState(false);

  const publishSurveyRequest = useCallback(async (id: string, request: SurveyPublishRequest) => {
    try {
      setLoading(true);
      return await publishSurvey(id, request);
    } finally {
      setLoading(false);
    }
  }, []);

  return { publishSurvey: publishSurveyRequest, loading };
};

export type UsePublishSurveyReturn = ReturnType<typeof usePublishSurvey>;
